<template>
	<SimulatorSheet :stepNum="stepNum" :stepName="stepName">
		<template #headerBody>
			<div>
				<div class="mb-20">
					<BSelector
						design="split"
						:options="simulationOptions.snowDeltasCfg.options"
						v-model="values.snow.cfgMode.deltaCfgOption"
					/>
				</div>

				<div class="grid--4">
					<BFieldBlock
						v-for="(num, index) in 3"
						:key="index"
						:label="`Ψ${index}`"
					>
						<BFieldNumber
							:disabled="values.snow.cfgMode.deltaCfgOption !== 'customized'"
							v-model="values.snow.deltas[index]"
							:min="0"
							:precision="2"
							:step="0.01"
						/>
					</BFieldBlock>
				</div>
			</div>
		</template>

		<div class="simulator__grid simulator__grid--1-2 mb-40">
			<div>
				<div class="sheet__controlTitle mb-20">{{ $t("Carga") }}</div>
				<ImageSnow class="sheet__image" />
			</div>
			<div>
				<BToggle v-model="values.snow.general.cfgMode.isSpanBySpan">
					{{ $t("Valor por vão") }}
				</BToggle>
			</div>
		</div>

		<div class="mb-60">
			<div
				class="simulator__grid simulator__grid--1-2"
				v-if="!values.snow.general.cfgMode.isSpanBySpan"
			>
				<div></div>
				<div>
					<div class="grid--4 align-items-end">
						<BFieldBlock :label="$t('Número de vãos')">
							<BFieldNumber
								:decimals="false"
								:step-btns="true"
								:disabled="true"
								:value="values.spans.main.length"
								:step="1"
								:precision="0"
								:min="0"
							/>
						</BFieldBlock>

						<BFieldBlock :label="$t('Carga distribuída')">
							<BFieldNumber
								:min="0"
								v-model="values.snow.general[sampleSpanType][0]"
								suffix="kN/m2"
								:precision="2"
								:step="0.01"
							/>
						</BFieldBlock>
					</div>
				</div>
			</div>

			<div
				class="simulator__grid simulator__grid--1"
				v-else-if="values.snow.general.cfgMode.isSpanBySpan"
			>
				<SimulatorSpanMappedValuesEditor
					:values="values.snow.general"
					:fieldProps="{
						suffix: 'kN/m2',
						min: 0,
						precision: 2,
						step: 0.01,
					}"
				/>
			</div>
		</div>

		<div class="mb-40">
			<div
				class="simulator__grid simulator__grid--1-2"
				v-if="!values.snow.exceptional.use"
			>
				<div></div>
				<div>
					<button
						class="sheet__bigAddBtn sheet__bigAddBtn--dark"
						@click="() => (values.snow.exceptional.use = true)"
					>
						{{ $t("Carga excecional") }} ({{ $t("opcional") }})
						<BIcon name="AddAlt" size="16"></BIcon>
					</button>
				</div>
			</div>

			<!-- TODO: FIX THIS STYLING HUGE FUKING MESS -->
			<div
				v-else
				class="simulator__grid"
				:class="
					values.snow.exceptional.cfgMode.isSpanBySpan
						? 'simulator__grid--1'
						: 'simulator__grid--1-2'
				"
			>
				<div v-if="!values.snow.exceptional.cfgMode.isSpanBySpan"></div>

				<div
					class="additionalFieldsCard"
					:class="{
						'is-large': values.snow.exceptional.cfgMode.isSpanBySpan,
					}"
				>
					<div
						class="simulator__grid"
						:class="
							values.snow.exceptional.cfgMode.isSpanBySpan
								? 'simulator__grid--1-2'
								: 'simulator__grid--1'
						"
					>
						<div v-if="values.snow.exceptional.cfgMode.isSpanBySpan"></div>

						<div class="additionalFieldsCard__constrained">
							<div class="flex align-items-center justify-between mb-30">
								<p class="font-size-l color-neutral-900">
									{{ $t("Carga excecional") }} ({{ $t("opcional") }})
								</p>

								<div class="flex">
									<!-- <BBtn
										size="m"
										variant="text"
										shape="circle"
										color="secondary"
										@click="handleRefreshExceptionalLoadBtnClick"
									>
										<BIcon name="Reset" size="20px" />
									</BBtn> -->
									<BBtn
										size="m"
										variant="text"
										shape="circle"
										color="secondary"
										@click="handleDeleteExceptionalLoadBtnClick"
									>
										<BIcon name="Delete" size="20px" />
									</BBtn>
								</div>
							</div>

							<div class="mb-40">
								<BToggle v-model="values.snow.exceptional.cfgMode.isSpanBySpan">
									{{ $t("Valor por vão") }}
								</BToggle>
							</div>

							<div
								class="grid--4 align-items-end"
								v-if="!values.snow.exceptional.cfgMode.isSpanBySpan"
							>
								<BFieldBlock :label="$t('Número de vãos')">
									<BFieldNumber
										:decimals="false"
										:step-btns="true"
										:disabled="true"
										:value="values.spans.main.length"
										:step="1"
										:precision="0"
										:min="0"
									/>
								</BFieldBlock>

								<BFieldBlock :label="$t('Carga distribuída')">
									<BFieldNumber
										:min="0"
										v-model="values.snow.exceptional[sampleSpanType][0]"
										suffix="kN/m2"
										:precision="2"
										:step="0.01"
									/>
								</BFieldBlock>
							</div>
						</div>
					</div>

					<SimulatorSpanMappedValuesEditor
						v-if="values.snow.exceptional.cfgMode.isSpanBySpan"
						:values="values.snow.exceptional"
						:fieldProps="{
							suffix: 'kN/m2',
							min: 0,
							precision: 2,
							step: 0.01,
						}"
					/>
				</div>
			</div>
		</div>

		<div class="simulator__grid simulator__grid--1-2 mb-40">
			<div></div>
			<div>
				<button
					class="sheet__bigAddBtn sheet__bigAddBtn--dark"
					@click="() => (values.snow.snowAccumulation.use = true)"
					v-if="!values.snow.snowAccumulation.use"
				>
					{{ $t("Acumulação de neve") }}
					<BIcon name="AddAlt" size="16"></BIcon>
				</button>

				<div class="additionalFieldsCard" v-else>
					<div class="flex align-items-center justify-between mb-30">
						<p class="font-size-l color-neutral-900">
							{{ $t("Acumulação de neve") }}
						</p>

						<div class="flex">
							<BBtn
								size="m"
								variant="text"
								shape="circle"
								color="secondary"
								@click="handleRefreshSnowAccumulationBtnClick"
							>
								<BIcon name="Reset" size="20px" />
							</BBtn>
							<BBtn
								size="m"
								variant="text"
								shape="circle"
								color="secondary"
								@click="handleDeleteSnowAccumulationBtnClick"
							>
								<BIcon name="Delete" size="20px" />
							</BBtn>
						</div>
					</div>

					<div>
						<div class="grid--4 mb-60">
							<BFieldBlock
								v-for="(item, idx) in values.snow.snowAccumulation.s"
								:key="idx"
								:label="`S${idx + 1}`"
							>
								<BFieldNumber
									:min="0"
									v-model="values.snow.snowAccumulation.s[idx]"
									suffix="kN/m2"
									:precision="2"
									:step="0.01"
								/>
							</BFieldBlock>
						</div>

						<div class="grid--4">
							<BFieldBlock
								v-for="(item, idx) in values.snow.snowAccumulation.l"
								:key="idx"
								:label="`L${idx + 1}`"
							>
								<BFieldNumber
									:min="0"
									:max="
										getMaxForLengthField({
											lengthFields: values.snow.snowAccumulation.l,
											idx,
										})
									"
									v-model="values.snow.snowAccumulation.l[idx]"
									suffix="m"
									:precision="2"
									:step="0.01"
								/>
							</BFieldBlock>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="sheet__footer">
			<BBtn
				size="l"
				variant="text"
				@click="handleRestartBtnClick"
				:disabled="isSaving"
				>{{ $t("Reiniciar") }}</BBtn
			>
			<BBtn size="l" @click="handleSaveBtnClick" :disabled="isSaving">{{
				$t("Salvar e Continuar")
			}}</BBtn>
		</div>
	</SimulatorSheet>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { deepClone } from "@/utils";

import SimulatorSheet from "./SimulatorSheet.vue";

import BSelector from "@/components/base/BSelector.vue";
import BSelect from "@/components/base/BSelect.vue";
import BFieldBlock from "@/components/base/BFieldBlock.vue";
import BCheckbox from "@/components/base/BCheckbox.vue";
import BFieldNumber from "@/components/base/BFieldNumber.vue";
import BBtn from "@/components/base/BBtn.vue";
import BToggle from "@/components/base/BToggle.vue";
import BIcon from "@/components/base/BIcon/index.vue";

import ImageSnow from "./Images/ImageSnow.vue";

import SimulatorSpanMappedValuesEditor from "./SimulatorSpanMappedValuesEditor";

import mixinEmitLifecycleEvents from "@/mixins/emitLifecycleEvents";
import mixinObserveChanges from "@/pages/Simulator/mixins/observeChanges";
import { getDefaultsSnow } from "../../store/modules/simulations/models/simulationDefaults";

export default {
	components: {
		BSelector,
		BToggle,
		BFieldBlock,
		BCheckbox,
		BSelect,
		BFieldNumber,
		BBtn,
		BIcon,
		SimulatorSheet,
		SimulatorSpanMappedValuesEditor,
		ImageSnow,
	},
	mixins: [mixinEmitLifecycleEvents, mixinObserveChanges],
	props: {
		...SimulatorSheet.props,
	},
	data() {
		return {
			values: null,
			isSaving: false,
		};
	},
	computed: {
		...mapState("simulator", {
			simulationOptions: "simulationOptions",
			simulationDefaults: "simulationDefaults",
			storeSimulation: "simulation",
		}),

		storeValues() {
			return this.storeSimulation.values;
		},
		...mapGetters("simulator", ["getMaxForLengthField"]),
	},
	methods: {
		...mapMutations("simulator", ["setSimulationValues"]),
		...mapActions("simulator", ["save"]),

		handleSaveBtnClick() {
			this.$emit("save", this.values);
		},

		handleRestartBtnClick() {
			this.$emit("restart");
		},

		handleRefreshSnowAccumulationBtnClick() {
			const snowDefaults = getDefaultsSnow({ spans: this.values.spans });

			this.values.snow.snowAccumulation = {
				...snowDefaults.snowAccumulation,
				use: true,
			};
		},
		handleRefreshExceptionalLoadBtnClick() {
			const snowDefaults = getDefaultsSnow({ spans: this.values.spans });

			this.values.snow.exceptional = {
				...snowDefaults.exceptional,
				use: true,
			};
		},

		handleDeleteSnowAccumulationBtnClick() {
			this.values.snow.snowAccumulation.use = false;
		},

		handleDeleteExceptionalLoadBtnClick() {
			this.values.snow.exceptional.use = false;
		},
	},

	watch: {
		"values.snow.snowAccumulation.use": {
			handler(use) {
				const snowDefaults = getDefaultsSnow({ spans: this.values.spans });

				if (!use) {
					this.values.snow.snowAccumulation = {
						...snowDefaults.snowAccumulation,
						use: false,
					};
				}
			},
		},
		"values.snow.exceptional.use": {
			handler(use) {
				const snowDefaults = getDefaultsSnow({ spans: this.values.spans });

				if (!use) {
					this.values.snow.exceptional = {
						...snowDefaults.exceptional,
						use: false,
					};
				}
			},
		},
		"values.snow.general": {
			handler(val) {
				if (!val.cfgMode.isSpanBySpan) {
					const sampleItem = val[this.sampleSpanType][0];
					["main", "console"].forEach((spanType) => {
						val[spanType].forEach((item, idx) => {
							val[spanType][idx] = sampleItem;
						});
					});
				}
			},
			deep: true,
		},
		"values.snow.exceptional": {
			handler(val) {
				if (!val.cfgMode.isSpanBySpan) {
					const sampleItem = val[this.sampleSpanType][0];

					["main", "console"].forEach((spanType) => {
						val[spanType].forEach((item, idx) => {
							val[spanType][idx] = sampleItem;
						});
					});
				}
			},
			deep: true,
		},
		"values.snow.cfgMode.deltaCfgOption": {
			handler(val) {
				this.values.snow.deltas = this.simulationOptions.snowDeltasCfg.options.find(
					(option) => option.id === val
				).deltas;
			},
		},
	},

	created() {
		this.values = deepClone(this.storeValues);
		this.sampleSpanType = this.values.spans.useConsole ? "console" : "main";
	},
};
</script>

<style lang="scss"></style>
